// @ts-nocheck
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadWishListLines,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import { BunzlActions } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Dispatch } from "react";

addToChainAfter(chain, DispatchCompleteLoadWishListLines, ({ apiParameter, apiResult, dispatch }) => {
    const bunzlDispatch = dispatch as unknown as Dispatch<BunzlActions>;
    if (apiResult && apiParameter.additionalQueryStringParameters?.IncludeCategory) {
        bunzlDispatch({
            type: "Pages/MyListDetails/LoadWishListDetailsCategory",
            parameter: apiParameter,
            wishListLines: apiResult,
        });
    }
});
